interface IMockedPlantSections {
  code: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
}

export const mockedPlatSections: IMockedPlantSections[] = [
  {
    projectIds: [38, 39, 40],
    code: 'BIL.F2C',
    description: 'FUELS 2C Asphalt/BOHO/TK Farms/U-ll/Offsites',
    isActive: true,
    id: 116,
  },
  {
    projectIds: [38, 39, 40],
    code: 'BIL.F2A',
    description: 'FUELS 2A CHUB/FCCU/ULEB/SLEB',
    isActive: true,
    id: 117,
  },
  {
    projectIds: [38],
    code: 'BIL.MEG',
    description: 'MECHANICAL ENGINEERING',
    isActive: true,
    id: 118,
  },
  {
    projectIds: [],
    code: 'BIL.SAG',
    description: 'SAFETY',
    isActive: true,
    id: 119,
  },
  {
    projectIds: [],
    code: 'BIL.MTG',
    description: 'MANAGEMENT TEAM',
    isActive: true,
    id: 120,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.F1A',
    description: 'FUELS 1A Crude/Coker/HF#2&3',
    isActive: true,
    id: 121,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.F1B',
    description: 'FUELS 1B Alky Patch/PoFo/HF#1',
    isActive: true,
    id: 122,
  },
  {
    projectIds: [39],
    code: 'BIL.ENG',
    description: 'ENVIROMENTAL ENGINEERING',
    isActive: true,
    id: 123,
  },
  {
    projectIds: [39],
    code: 'BIL.MAG',
    description: 'MECHANICAL ADMINISTRATION',
    isActive: true,
    id: 124,
  },
  {
    projectIds: [40],
    code: 'BIL.F2B',
    description: 'FUELS 2B HYBL/HCBL',
    isActive: true,
    id: 125,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.SHO',
    description: 'SHOPS Mech. & Contractor Shops & Equip.',
    isActive: true,
    id: 126,
  },
  {
    projectIds: [40],
    code: 'BIL.F1C',
    description: 'FUELS 1C OCC',
    isActive: true,
    id: 127,
  },
  {
    projectIds: [],
    code: 'BIL.MTN',
    description: 'MAINTENANCE',
    isActive: true,
    id: 128,
  },
  {
    projectIds: [40],
    code: 'BIL.LAB',
    description: 'LABORATORY',
    isActive: true,
    id: 129,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.MOT',
    description: 'MOTORIZED EQUIPMENT',
    isActive: true,
    id: 130,
  },
  {
    projectIds: [39],
    code: 'BIL.RSG',
    description: 'REFINERY SERVICES',
    isActive: true,
    id: 133,
  },
  {
    projectIds: [],
    code: 'BIL.IHY',
    description: 'INDUSTRIAL HYGENE',
    isActive: true,
    id: 134,
  },
  {
    projectIds: [40],
    code: 'BIL.SWG',
    description: 'SOLID WASTE',
    isActive: true,
    id: 142,
  },
  {
    projectIds: [],
    code: 'BIL.TEG',
    description: 'TECHNICAL ADMINISTRATION',
    isActive: true,
    id: 371,
  },
]
